// src/data/services.js
export const INITIAL_SERVICES = [
  {
    id: "srv-1",
    name: "General Health Consultation",
    category: "Primary Care",
    duration: 30, // minutes
    price: 65,
    description: "Comprehensive medical assessment, vitals check, routine prescriptions, and preventive care guidance.",
    icon: "stethoscope",
    badgeColor: "#3b82f6"
  },
  {
    id: "srv-2",
    name: "Dental Cleaning & Examination",
    category: "Dentistry",
    duration: 45,
    price: 95,
    description: "Deep dental prophylaxis, plaque removal, fluoride treatment, and oral hygiene assessment.",
    icon: "tooth",
    badgeColor: "#10b981"
  },
  {
    id: "srv-3",
    name: "Cardiology Review & ECG",
    category: "Cardiology",
    duration: 60,
    price: 150,
    description: "Cardiac rhythm analysis, resting 12-lead ECG review, cardiovascular risk assessment and advice.",
    icon: "heart-pulse",
    badgeColor: "#ef4444"
  },
  {
    id: "srv-4",
    name: "Dermatology Skin Screening",
    category: "Dermatology",
    duration: 30,
    price: 110,
    description: "Full-body dermoscopic mole check, skin lesion evaluation, acne therapy, and biopsy consultation.",
    icon: "spa",
    badgeColor: "#f59e0b"
  },
  {
    id: "srv-5",
    name: "Pediatric Wellness Check",
    category: "Pediatrics",
    duration: 40,
    price: 80,
    description: "Child developmental milestones check, physical growth measurement, and immunization review.",
    icon: "baby",
    badgeColor: "#8b5cf6"
  },
  {
    id: "srv-6",
    name: "Orthopedic Physical Therapy",
    category: "Physiotherapy",
    duration: 50,
    price: 120,
    description: "Targeted musculoskeletal rehab, post-injury mobilization, joint stability, and posture correction.",
    icon: "bone",
    badgeColor: "#06b6d4"
  }
];
